import { groupBy } from "lodash"
import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ConfirmModal from "../../components/Common/ConfirmModal"
import { separateObject } from "../../utils/commonFunctions"
import MasterOrNewParcel from "./MasterOrNewParcel"

const SplitParcelsModal = ({
    show,
    setShow,
    handleClose,
    data,
    handleSubmit,
    loading,
    fulfillmentSuites = undefined
}: {
    show: string
    setShow: Function
    handleClose: () => void
    data: Record<string, any>
    handleSubmit: Function
    loading: boolean
    fulfillmentSuites?: Record<string, any>[]
}) => {
    const { t } = useTranslation()
    const [parcelItems, setParcelItems] = useState([] as Record<string, any>[])
    const [newParcels, setNewParcels] = useState([] as any[])
    const [fulfilledItems, setFulfilledItems] = useState([] as any[])
    const [selectedItems, setSelectedItems] = useState([] as Record<string, any>[])
    const [splittedItems, setSplittedItems] = useState({} as Record<string, any>)
    const [isInvalid, setIsInValid] = useState([] as number[])
    const [counter, setCounter] = useState(1)

    useEffect(() => {
        if (data?.ParcelItems?.length > 0) {
            if (!data?.fulfillment_request_status_id || Number(data?.fulfillment_request_status_id) === 1) {
                setParcelItems(data?.ParcelItems)
            }
            if (show === "viewParcel") {
                let groupedData = groupBy(data?.FulfilledItems, "FulfillmentSuite.suite")
                let tempData = separateObject(groupedData)
                setNewParcels([...tempData])
            }
        }
    }, [data?.ParcelItems?.length, data?.fulfillment_request_status_id])

    return (
        <>
            <Modal
                show={["assignItems", "splitParcel", "viewParcel"].includes(show)}
                onHide={() => {
                    setNewParcels([])
                    setSelectedItems([])
                    setSplittedItems({})
                    setCounter(1)
                    setIsInValid([])
                    handleClose()
                }}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Modal.Header className="bg-light" closeButton>
                    <Modal.Title>
                        <span className="text-muted">
                            {["assignItems", "viewParcel"].includes(show)
                                ? t("Assign Fulfillment Area")
                                : t("Split Parcel")}{" "}
                            :
                        </span>
                        &nbsp;&nbsp;{data?.uuid}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-light">
                    {parcelItems?.length > 0 && show !== "viewParcel" && (
                        <MasterOrNewParcel
                            masterParcel={true}
                            parcelItems={parcelItems}
                            setParcelItems={setParcelItems}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}
                            isInvalid={isInvalid}
                            setIsInValid={setIsInValid}
                            splittedItems={splittedItems}
                            setSplittedItems={setSplittedItems}
                            newParcels={newParcels}
                            setNewParcels={setNewParcels}
                            counter={counter}
                            setCounter={setCounter}
                            assign={show === "assignItems"}
                            view={show === "viewParcel"}
                            fulfillmentSuites={fulfillmentSuites}
                        />
                    )}
                    {newParcels?.map((newParcel: any[], index: number) => (
                        <MasterOrNewParcel
                            masterParcel={false}
                            parcelItems={parcelItems}
                            setParcelItems={setParcelItems}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}
                            isInvalid={isInvalid}
                            setIsInValid={setIsInValid}
                            splittedItems={splittedItems}
                            setSplittedItems={setSplittedItems}
                            newParcels={newParcels}
                            setNewParcels={setNewParcels}
                            counter={counter}
                            setCounter={setCounter}
                            NewParcelUuid={`${data?.uuid}-${index + 1}`}
                            NewParcelId={Object.keys(newParcel)[0] || ""}
                            originalParcelItems={data?.ParcelItems}
                            index={index}
                            assign={show === "assignItems"}
                            view={show === "viewParcel"}
                            fulfillmentSuites={fulfillmentSuites}
                        />
                    ))}
                </Modal.Body>
                {show !== "viewParcel" && (
                    <Modal.Footer>
                        <Button
                            disabled={newParcels?.length <= 0}
                            id="btn-primary"
                            className="primary-bg border-0"
                            type="submit"
                            onClick={() => setShow("splitConfirmModal")}>
                            {/* {loading ? 
				 	<div className="spinner-border text-light" role="status"></div> :*/}
                            {t("Save")}
                            {/* } */}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
            <ConfirmModal
                show={show}
                data={newParcels}
                handleClose={() => {
                    setNewParcels([])
                    setSelectedItems([])
                    setSplittedItems({})
                    setCounter(1)
                    setIsInValid([])
                    handleClose()
                }}
                title={show === "assignItems" ? t("Confirm") : t("Split parcel confirmation")}
                handleSubmit={handleSubmit}
                loading={loading}
            />
        </>
    )
}

export default SplitParcelsModal
